import {Flex} from "antd";
import classes2 from "../../About/about.module.css";
import {clrs} from "../../../constants/colors";
import MyText from "../../../components/UI/Text/MyText";
import React from "react";

export const UserCard = ({user, setOpen, setTargetName, setModalTarget}) => {
    return (
        <Flex className={classes2.userCard} style={{width: 250, height: 450, border: `1px solid ${clrs.whiter}`, position: "relative", textAlign: "center", cursor: "pointer"}}  onClick={
            () => {
                setOpen(true);
                setTargetName(user.name);
                setModalTarget(user.targetObject)
            }
        } align={"center"} justify={"flex-start"} gap={15} vertical>
            <div
                style={{
                    width: 250,
                    height: 300,
                    backgroundImage: `url(${user.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    overflow: "hidden"
                }}
            ></div>
            <Flex style={{width: "calc(100% - 40px)", paddingLeft: 20, paddingRight: 20}} align={"center"} justify={"center"} vertical gap={10}>
                <MyText strong>
                    {user.name}
                </MyText>
                <MyText italic style={{color: clrs.whiterBlacker}}>
                    {user.role}
                </MyText>
            </Flex>
        </Flex>
    )
}

